import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { textAlign } from 'utils';

/**
 * Recharts' `Tooltip` portals its wrapper out of the `Gauge`'s own DOM
 * subtree and paints no background of its own, so this content needs its
 * own top-level styled component rather than a nested selector, and is
 * fully responsible for its own box.
 */
export const StyledGaugeTooltip = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 2px;
    background-color: ${theme.palette.secondary.lightest};
    padding: 8px 12px;
    border-radius: 4px;

    .tooltip-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    .tooltip-value {
      /* Figma's "Secondary/Main" (#0C395A) — distinct from this theme's
         palette.secondary, which repurposes that slot for an accent color. */
      color: #0c395a;
      font-size: ${theme.typography.overline.fontSize};
      line-height: 16px;
      white-space: nowrap;
      direction: ltr;
    }

    .tooltip-label {
      color: ${theme.palette.secondary.lighter};
      font-size: 8px;
      line-height: 16px;
      width: 68px;
      ${textAlign('right')}
    }
  `
);
